<script setup lang="ts">
/**
 * The full-screen loading modal: dimmed, blurred backdrop with the standard
 * spinner centred. Driven entirely by stores/loading.ts — route navigations
 * and initial view-data fetches show it; background polls never do.
 *
 * z-[100]: above the swap lock screen (z-[90]) — if both are active, "the app
 * is fetching" is the more immediate truth.
 */
import { useI18n } from 'vue-i18n';
import { useLoadingStore } from '@/stores/loading';

const { t } = useI18n();
const loading = useLoadingStore();
</script>

<template>
  <Transition name="loading-fade">
    <div
      v-if="loading.visible"
      class="fixed inset-0 z-[100] flex items-center justify-center bg-ink-950/60 backdrop-blur-sm"
      role="status"
      :aria-label="t('common.loading')"
    >
      <svg
        class="h-10 w-10 animate-spin text-brass-400"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        aria-hidden="true"
      >
        <path d="M12 3a9 9 0 1 0 9 9" />
      </svg>
    </div>
  </Transition>
</template>

<style scoped>
.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.18s ease;
}
.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
}
</style>
